import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { useBrandContext } from '../../context/BrandContext';
import { useHeaderContext } from '../../context/HeaderContext';

import './PrivacyPolicy.css';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();
  const { brandName } = useBrandContext();
  const { setHeaderConfig } = useHeaderContext();

  const [iframeSrc, setIframeSrc] = useState<string | null>(null);

  useEffect(() => {
    const path = `/${brandName}/policy.txt`;

    const checkFileExists = async () => {
      try {
        const res = await fetch(path, { redirect: 'manual' });
        const text = await res.text();
        if (text.includes('<html')) {
          setIframeSrc('/spott/policy.txt');
        } else {
          setIframeSrc(path);
        }
      } catch (error) {
        console.error('Erro ao verificar o arquivo:', error);
        setIframeSrc(null);
      }
    };

    checkFileExists();
  }, [brandName]);

  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    const handleLoad = () => {
      try {
        const iframe = iframeRef.current;
        const html = iframe?.contentDocument?.querySelector('html');
        const pre = iframe?.contentDocument?.querySelector('pre');

        if (html) {
          html.style.backgroundColor = '#ffffff';
        }
        if (pre) {
          pre.style.fontFamily = 'Outfit, Gilroy, sans-serif';
          pre.style.fontSize = '16px';
          pre.style.color = '#1a1a1a';
          pre.style.backgroundColor = '#f9f9f9';
          pre.style.padding = '1rem';
        }
      } catch (error) {
        console.warn('Não foi possível acessar o conteúdo do iframe:', error);
      }
    };

    const iframe = iframeRef.current;
    if (iframe) {
      iframe.addEventListener('load', handleLoad);
    }

    return () => {
      if (iframe) {
        iframe.removeEventListener('load', handleLoad);
      }
    };
  }, []);

  useEffect(() => {
    setHeaderConfig({
      headerText: 'Política de Privacidade',
      showLogo: true,
      backNavigation: () => navigate(`/${brandName}/userProfile`),
    });
    return () => setHeaderConfig({});
  }, [brandName, navigate, setHeaderConfig]);

  return (
    <div className='payment-methods-container'>
      <iframe
        title='Privacy Policy'
        ref={iframeRef}
        src={iframeSrc || ''}
        style={{
          border: 0,
          width: '100%',
          height: 'calc(100vh - 340px)',
        }}
      />
    </div>
  );
};

export default PrivacyPolicy;
